import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { EventBus } from '@/utils/eventBus'
import { currencyFilter } from '@/utils/string'
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'
import { isExpiredV2 } from '@/utils/quote'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteSummaryPrice',
  props: {
    row: null
  },
  setup(__props: any) {

const props = __props as {
  row: QuoteSummary
};



const hasSpecialScenario = computed(() => {
  return props.row.promptCall || props.row.salesWillCall || props.row.promptBASCall
})

const displayText = computed(() => {
  const isPastExpiration = props.row.expirationDatetime && isExpiredV2(props.row.expirationDatetime)
  const isPickupInPast = props.row.pickupDatetime && new Date(props.row.pickupDatetime) < new Date()
  if (isPastExpiration || isPickupInPast) {
    return 'Expired'
  }

  if (hasSpecialScenario.value) {
    return 'More Info'
  }

  if (!props.row.price) {
    return 'View Prices'
  }

  return currencyFilter(props.row.price)
})

const openDialog = () => {
  const { promptCall, salesWillCall, promptBASCall } = props.row
  if (promptCall) {
    EventBus.$emit('open-prompt-call-dialog')
  } else if (salesWillCall) {
    EventBus.$emit('open-sales-will-call-dialog')
  } else if (promptBASCall) {
    EventBus.$emit('open-prompt-call-for-bas-dialog')
    return
  }
}

return { __sfc: true,props, hasSpecialScenario, displayText, openDialog }
}

})